import{a as p}from"./chunk-RAAYCPUM.js";function r(...e){return p(t,e)}var t=e=>e.toUpperCase();export{r as a};
